import * as React from "react";
import ReactDOM from "react-dom";
import {inject, observer} from "mobx-react";
import Grid from "@components/Grid/Grid";
import MarketSelector from "@components/Navigation/market-selector";


class ChangeCountry extends React.Component {
    constructor(props) {
        super(props);


    }

    render() {
        const navigation = this.props.navigation;

        const currentCountry = navigation.CountryCode
            ? navigation.mainTree.Countries.find(country => country.CountryCode === navigation.CountryCode)
            : navigation.mainTree.Countries.find(country => country.MarketCode === navigation.MarketCode);

        return (
            <React.Fragment>
                <div className="market-current" ref="marketSelector" onClick={() => this.toggleMarketSelector()}>
                    {currentCountry &&
                        <React.Fragment>
                            <img src={"/dist/img/flags/" + currentCountry.CountryCode + ".svg"} alt={currentCountry.MarketCode}/> {currentCountry.CountryName} {}
                        </React.Fragment>

                    }
                </div>

            </React.Fragment>);
    }
}

@inject("store")
@observer
export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const changeCountrySelector = document.querySelector('#ChangeCountry');
        if (changeCountrySelector) {
            ReactDOM.render(<MarketSelector navigation={this.props.store.navigation}/>, document.querySelector('#ChangeCountry'));
        }

    }


    render() {
        return (
            <footer className="site-footer">
                <div className="wrapper">
                    <Grid {...this.props} model={this.props.store.navigation.footerContent}/>
                </div>

                {/*<div className="container-fluid">*/}
                {/*    <div className="row">*/}
                {/*        <div className="col-6" style={{ textAlign: "right" }}>*/}
                {/*            <img src="https://cdn.klarna.com/1.0/shared/image/generic/badge/sv_se/checkout/long-white.png?width=440" />*/}
                {/*        </div>*/}
                {/*        <div className="col-6">*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}


            </footer>
        );
    }
}


